import React from "react";
import styles from "./Avatar.module.css";
import { resolveUploadUrl } from "../../utils/apiClient";
import { getInitials } from "../../utils/avatarUtils";

export default function Avatar({
  name,
  imageUrl,
  size = "sm",
  variant = "default",
  color,
  round = false,
  alt,
}) {
  const sizeClass =
    size === "lg" ? styles.sizeLg : size === "md" ? styles.sizeMd : styles.sizeSm;
  const variantClass = variant === "contractor" ? styles.contractor : "";
  const className = [styles.avatar, sizeClass, variantClass, round && styles.round]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={className}
      aria-hidden={!alt}
      style={color && { background: `${color}1f`, borderColor: `${color}40`, color }}
    >
      {imageUrl ? (
        <img src={resolveUploadUrl(imageUrl)} alt={alt || name || ""} />
      ) : (
        <span>{getInitials(name)}</span>
      )}
    </div>
  );
}
